/* AG SEO Studio, editor client.
   Talks to scripts/ag-seo-studio-app.gs. Edits the SEO override fields
   Shopify stores as global.title_tag / global.description_tag. An empty
   SEO title is fine (theme falls back to name + brand); an empty meta
   description is genuinely missing. See scripts/AG-SEO-STUDIO.md. */
(function () {
  var CFG = window.AG_SEO_STUDIO_CONFIG;
  if (!CFG || !CFG.endpoint) return;
  // AI "✨ Suggest" (Phase 2b) is HIDDEN by default, it is the only feature that
  // makes a paid Anthropic API call. To re-enable: set this to true AND add the
  // ANTHROPIC_API_KEY Script Property on the ag-seo-studio-script Apps Script.
  var AI_SUGGEST = false;
  var mount = document.querySelector(CFG.rootSelector);
  if (!mount) return;
  var studio = mount.closest('.ag-seo-studio') || mount;

  var TYPES = ['product', 'collection', 'page', 'article'];
  var state = { pw: '', items: [], type: 'all', q: '', issue: null, onlyIssues: true, view: 'editor', failed: [], loading: false };

  // ---- backend call ----
  // When the OTP shell (AG-Admin-Shell) is present, route every call through
  // window.AG_ADMIN.api → the auth Worker's gate+proxy, which checks the caller's
  // OTP session + 'seo-studio' section and injects the staff password server-side. The
  // browser never holds a password. If the shell is somehow absent (fallback),
  // fall back to the legacy direct /exec call with the typed staff password.
  function call(action, extra) {
    if (window.AG_ADMIN && typeof window.AG_ADMIN.api === 'function') {
      return window.AG_ADMIN.api(action, extra || {});
    }
    var body = Object.assign({ action: action, password: state.pw }, extra || {});
    return fetch(CFG.endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'text/plain;charset=utf-8' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); }).then(function (d) {
      if (d && d.error === 'auth') { var e = new Error('auth'); e.auth = true; throw e; }
      if (d && d.error) throw new Error(d.error);
      return d;
    });
  }

  // ---- pixel width: what Google truncates on, character counts are only a proxy ----
  // Desktop SERP cut-offs, measured the way Google renders them (Arial, 20px for
  // titles, 14px for descriptions). A 58-character title can be 574px and fit;
  // a 150-character description is often 950px and gets cut.
  var TITLE_PX = 580, META_PX = 920, SHOP_NAME = 'Assassin Goods';
  var _mctx = null;
  function textPx(str, font) {
    if (!_mctx) { try { _mctx = document.createElement('canvas').getContext('2d'); } catch (e) { _mctx = null; } }
    if (!_mctx) return 0;
    _mctx.font = font;
    return Math.round(_mctx.measureText(str || '').width);
  }
  function titlePx(str) { return textPx(str, '20px Arial'); }
  function metaPx(str) { return textPx(str, '14px Arial'); }
  // Measure the title AS RENDERED, not as stored: the theme appends " | Assassin Goods"
  // whenever the SEO title lacks the shop name, and Shopify falls back to the
  // resource title when the field is blank. Measuring the stored string alone
  // under-reads by ~150px.
  function renderedTitle(x, val) {
    var v = (val == null ? x.seoTitle : val); v = (v || '').trim();
    if (!v) v = (x.title || '').trim();
    if (v && v.indexOf(SHOP_NAME) < 0) v += ' | ' + SHOP_NAME;
    return v;
  }

  // ---- issue model (on the editable override fields) ----
  function metaLen(x) { return (x.seoDescription || '').trim().length; }
  function titleLen(x) { return (x.seoTitle || '').trim().length; }
  function issues(x) {
    var out = [];
    if (metaLen(x) === 0) out.push('no-meta');
    else if (metaPx((x.seoDescription || '').trim()) > META_PX) out.push('meta-long');
    if (titlePx(renderedTitle(x)) > TITLE_PX) out.push('title-long');
    if ((x.seoTitle || '').split('|').length - 1 >= 2) out.push('title-stuffed');
    return out;
  }
  function hasIssue(x) { return issues(x).length > 0; }

  // ---- tiny DOM helper ----
  function h(tag, attrs, kids) {
    var e = document.createElement(tag);
    if (attrs) Object.keys(attrs).forEach(function (k) {
      if (k === 'class') e.className = attrs[k];
      else if (k === 'html') e.innerHTML = attrs[k];
      else if (k.slice(0, 2) === 'on') e.addEventListener(k.slice(2), attrs[k]);
      else if (attrs[k] != null) e.setAttribute(k, attrs[k]);
    });
    (kids || []).forEach(function (c) { if (c) e.appendChild(typeof c === 'string' ? document.createTextNode(c) : c); });
    return e;
  }
  function esc(s) { return (s == null ? '' : String(s)); }
  // table header cell with an optional (i) tooltip explaining the ideal SEO
  function colTh(label, tip) {
    var kids = [label];
    if (tip) kids.push(h('span', { class: 'info', tabindex: '0', role: 'note', 'aria-label': tip }, ['i', h('span', { class: 'tip' }, [tip])]));
    return h('th', null, kids);
  }

  // ---- auth gate ----
  function renderGate(msg) {
    studio.setAttribute('data-theme', savedTheme());
    mount.innerHTML = '';
    var err = h('div', { class: 'err' }, [msg || '']);
    var input = h('input', { class: 'in', type: 'password', placeholder: 'Staff password', autofocus: 'true' });
    var form = h('form', { onsubmit: function (ev) {
      ev.preventDefault();
      state.pw = input.value;
      err.textContent = '';
      var btn = form.querySelector('button'); btn.disabled = true; btn.textContent = 'Checking…';
      loadAll().then(renderApp).catch(function (e) {
        btn.disabled = false; btn.textContent = 'Unlock';
        err.textContent = e && e.auth ? 'Wrong password.' : ('Error: ' + (e && e.message || e));
        if (e && e.auth) { state.pw = ''; }
      });
    } }, [input, h('button', { class: 'btn', type: 'submit' }, ['Unlock'])]);
    mount.appendChild(h('div', { class: 'bar' }, [
      h('a', { class: 'brand', href: '/pages/admin', html: 'AG <span class="red">ADMIN</span>' }),
      h('span', { class: 'divider' }, ['|']),
      h('span', { class: 'toolname' }, ['SEO Studio']),
      h('span', { class: 'sp' }),
      h('a', { class: 'hublink', href: '/pages/admin' }, ['← Hub'])
    ]));
    mount.appendChild(h('div', { class: 'gate' }, [
      h('h2', null, ['SEO Studio']),
      h('div', { class: 'ag-muted', html: 'Edit SEO titles &amp; meta descriptions across the store.' }),
      form, err
    ]));
    var i = mount.querySelector('input'); if (i) i.focus();
  }

  // ---- load every resource, paginated, resilient per type ----
  function loadAll() {
    state.items = []; state.failed = [];
    var bar = document.querySelector('.ag-seo-progress');
    function step(t) {
      var cursor = null;
      function page() {
        return call('list', { type: t, cursor: cursor }).then(function (d) {
          (d.items || []).forEach(function (x) { state.items.push(x); });
          cursor = d.nextCursor;
          if (bar) bar.textContent = 'Loaded ' + state.items.length + '…';
          if (cursor) return page();
        });
      }
      return page().catch(function (e) {
        if (e && e.auth) throw e;
        state.failed.push(t + ' (' + (e && e.message || e) + ')');
      });
    }
    return TYPES.reduce(function (p, t) { return p.then(function () { return step(t); }); }, Promise.resolve());
  }

  // ---- app shell ----
  function renderApp() {
    studio.setAttribute('data-theme', savedTheme());
    mount.innerHTML = '';
    var themeBtn = h('button', { class: 'iconbtn', title: 'Toggle light / dark', onclick: toggleTheme }, [savedTheme() === 'dark' ? '☀' : '☾']);
    function vtab(v, label) { return h('button', { class: 'vtab' + (state.view === v ? ' on' : ''), onclick: function () { state.view = v; renderApp(); } }, [label]); }
    // Brand / tool-name / hub link / sign-out now live in the AG-Admin-Shell top
    // bar. When the shell is absent (legacy fallback) keep them so navigation
    // still works.
    var barKids = [];
    if (!(window.AG_ADMIN && typeof window.AG_ADMIN.api === 'function')) {
      barKids.push(
        h('a', { class: 'brand', href: '/pages/admin', html: 'AG <span class="red">ADMIN</span>' }),
        h('span', { class: 'divider' }, ['|']),
        h('span', { class: 'toolname' }, ['SEO Studio'])
      );
    }
    barKids.push(h('div', { class: 'viewtabs' }, [vtab('editor', 'Editor'), vtab('audit', 'Audit')]));
    barKids.push(h('span', { class: 'sp' }));
    if (!(window.AG_ADMIN && typeof window.AG_ADMIN.api === 'function')) {
      barKids.push(h('a', { class: 'hublink', href: '/pages/admin' }, ['← Hub']));
    }
    barKids.push(themeBtn);
    mount.appendChild(h('div', { class: 'bar' }, barKids));
    var main = h('div', { class: 'main' });
    if (state.view === 'audit') { main.appendChild(auditView()); mount.appendChild(main); return; }
    main.appendChild(h('div', { class: 'grid', id: 'agseo-stats' }));
    var search = h('input', { class: 'in', type: 'search', placeholder: 'Search URL or name…', oninput: function (e) { state.q = e.target.value; renderRows(); } });
    var typeSel = h('select', { class: 'sel', onchange: function (e) { state.type = e.target.value; renderRows(); } },
      ['all'].concat(TYPES).map(function (t) { return h('option', { value: t }, [t === 'all' ? 'All types' : t + 's']); }));
    var onlyChk = h('input', { type: 'checkbox', checked: state.onlyIssues ? 'true' : null, onchange: function (e) {
      state.onlyIssues = e.target.checked;
      if (state.onlyIssues && state.issue === 'good') state.issue = null; // can't show "only issues" and "only healthy" at once
      renderRows();
    } });
    main.appendChild(h('div', { class: 'toolbar' }, [
      h('div', { class: 'search' }, [search]), typeSel,
      h('label', { class: 'chk' }, [onlyChk, 'Only rows with issues']),
      h('span', { class: 'count', id: 'agseo-count' })
    ]));
    if (state.failed.length) {
      main.appendChild(h('div', { class: 'rowstate bad', style: 'margin:0 0 10px' }, ['Couldn’t load: ' + state.failed.join(', ') + 'edit those in Shopify admin, or check the API version in the GAS.']));
    }
    main.appendChild(h('div', { class: 'pillbar', id: 'agseo-pills' }));
    var wrap = h('div', { class: 'tablewrap' });
    var table = h('table', null, [
      h('thead', null, [h('tr', null, [
        colTh('Type'), colTh('Page'),
        colTh('SEO title', 'Google cuts titles by width, about 580px in Arial 20px (roughly 50–60 characters, fewer if they are wide letters). One clear phrase, key term near the front, "| Assassin Goods" at the end. Leave blank and the theme renders "{name} | Assassin Goods" (fine). The meter measures the title as it renders, suffix included. Green = fits, amber = cut.'),
        colTh('Meta description', 'Google cuts descriptions by width, about 920px in Arial 14px on desktop (roughly 140–155 characters; 160 usually overflows). A unique, compelling summary with the key term + a reason to click. Blank = Google auto-writes a snippet from page text (avoid). Green = fits, amber = cut, red = missing.'),
        colTh('')
      ])]),
      h('tbody', { id: 'agseo-rows' })
    ]);
    wrap.appendChild(table); main.appendChild(wrap);
    mount.appendChild(main);
    renderRows();
  }

  function filtered() {
    return state.items.filter(function (x) {
      if (state.type !== 'all' && x.type !== state.type) return false;
      // 'good' is a pseudo-filter meaning "no issues", the inverse of the issue pills.
      if (state.issue === 'good') { if (hasIssue(x)) return false; }
      else if (state.issue && issues(x).indexOf(state.issue) < 0) return false;
      if (state.onlyIssues && !hasIssue(x)) return false;
      if (state.q) { var q = state.q.toLowerCase(); if ((x.url || '').toLowerCase().indexOf(q) < 0 && (x.title || '').toLowerCase().indexOf(q) < 0) return false; }
      return true;
    });
  }

  function meter(val, x, kind) {
    // kind 'title' | 'meta'. The bar and the colour follow pixel width against the
    // SERP cut-off; the label shows characters too because that is what people type to.
    var len = (val || '').trim().length;
    var limit = kind === 'meta' ? META_PX : TITLE_PX;
    var px = kind === 'meta' ? metaPx((val || '').trim()) : titlePx(renderedTitle(x, val));
    var cls, label, col, pct = Math.min(px / (limit * 1.25), 1) * 100;
    var title = kind === 'meta'
      ? 'Google cuts descriptions at about ' + META_PX + 'px on desktop'
      : 'Measured as rendered: "' + renderedTitle(x, val) + '". Google cuts titles at about ' + TITLE_PX + 'px';
    if (kind === 'meta' && len === 0) { cls = 'bad'; label = '0 · none'; col = 'var(--ag-bad)'; pct = 0; }
    else if (px > limit) { cls = 'warn'; label = len + ' ch · ' + px + 'px · cut'; col = 'var(--ag-warn)'; }
    else if (len === 0) { cls = ''; label = 'blank · ' + px + 'px'; col = 'var(--ag-muted)'; }
    else { cls = 'ok'; label = len + ' ch · ' + px + 'px'; col = 'var(--ag-ok)'; }
    var wrap = h('div', { class: 'meterline', title: title }, [
      h('div', { class: 'track' }, [h('i', { style: 'width:' + pct + '%;background:' + col })]),
      h('span', { class: 'cc ' + cls }, [label])
    ]);
    return wrap;
  }

  function renderRows() {
    var rows = filtered();
    var tb = document.getElementById('agseo-rows'); if (!tb) return;
    tb.innerHTML = '';
    if (!rows.length) { tb.appendChild(h('tr', null, [h('td', { colspan: '5', class: 'empty' }, ['Nothing to show. Try clearing filters.'])])); }
    rows.slice(0, 600).forEach(function (x) { tb.appendChild(rowEl(x)); });
    // stats
    var pool = state.items;
    // count of resources matching a stat key: 'good' = no issues, else has that issue
    function statCount(k) {
      return pool.filter(function (x) { return k === 'good' ? !hasIssue(x) : issues(x).indexOf(k) >= 0; }).length;
    }
    var stats = [
      { k: null, l: 'Total resources', c: '', n: pool.length },
      { k: 'good', l: 'Healthy', c: 'ok' },
      { k: 'no-meta', l: 'Missing meta', c: 'bad' },
      { k: 'meta-long', l: 'Meta too wide', c: 'warn' },
      { k: 'title-long', l: 'Titles too wide', c: 'warn' },
      { k: 'title-stuffed', l: 'Stuffed titles', c: 'warn' }
    ];
    var sc = document.getElementById('agseo-stats');
    if (sc) { sc.innerHTML = ''; stats.forEach(function (s) {
      var n = s.n != null ? s.n : statCount(s.k);
      var active = s.k != null && state.issue === s.k;
      sc.appendChild(h('button', { class: 'stat ' + s.c + (active ? ' active' : ''), onclick: function () {
        if (s.k == null) { state.issue = null; state.onlyIssues = false; }
        else if (s.k === 'good') { state.issue = (state.issue === 'good') ? null : 'good'; state.onlyIssues = false; }
        else { state.issue = (state.issue === s.k) ? null : s.k; }
        renderApp();
      } }, [h('div', { class: 'v' }, [String(n)]), h('div', { class: 'l' }, [s.l])]));
    }); }
    // issue filter pills (reuse the stat issue set; skip the 'Total' card)
    var pb = document.getElementById('agseo-pills');
    if (pb) { pb.innerHTML = '';
      stats.slice(1).forEach(function (s) {
        var n = statCount(s.k);
        if (!n) return;
        var on = state.issue === s.k;
        pb.appendChild(h('button', { class: 'pill ' + s.c + (on ? ' on' : ''), onclick: function () {
          state.issue = on ? null : s.k;
          if (s.k === 'good' && !on) state.onlyIssues = false; // showing healthy rows means don't hide them
          renderApp();
        } }, [s.l + ' ', h('span', { class: 'pc' }, [String(n)])]));
      });
      if (state.issue) { pb.appendChild(h('button', { class: 'pill clear', onclick: function () { state.issue = null; renderApp(); } }, ['✕ Clear filter'])); }
    }
    var cnt = document.getElementById('agseo-count');
    if (cnt) cnt.innerHTML = '<b>' + rows.length + '</b> of ' + pool.length + (rows.length > 600 ? ' (showing 600)' : '');
  }

  function rowEl(x) {
    var tr = h('tr');
    var titleIn = h('input', { class: 'in', type: 'text', value: esc(x.seoTitle) });
    var metaTa = h('textarea', null, []); metaTa.value = esc(x.seoDescription);
    var tMeter = meter(titleIn.value, x, 'title');
    var mMeter = meter(metaTa.value, x, 'meta');
    var saveBtn = h('button', { class: 'save', disabled: 'true' }, ['Save']);
    var st = h('div', { class: 'rowstate' }, ['']);
    function mark() {
      var dirty = titleIn.value !== esc(x.seoTitle) || metaTa.value !== esc(x.seoDescription);
      saveBtn.disabled = dirty ? null : 'true';
      tr.classList.toggle('dirty', dirty);
      tMeter.replaceWith(tMeter = meter(titleIn.value, x, 'title'));
      mMeter.replaceWith(mMeter = meter(metaTa.value, x, 'meta'));
    }
    titleIn.addEventListener('input', mark);
    metaTa.addEventListener('input', mark);
    saveBtn.addEventListener('click', function () {
      saveBtn.disabled = 'true'; st.className = 'rowstate'; st.innerHTML = '<span class="spinner"></span>';
      call('save', { type: x.type, id: x.id, seoTitle: titleIn.value, seoDescription: metaTa.value }).then(function (d) {
        if (d.userErrors && d.userErrors.length) {
          st.className = 'rowstate bad'; st.textContent = d.userErrors.map(function (u) { return u.message; }).join('; ');
          saveBtn.disabled = null; return;
        }
        x.seoTitle = titleIn.value; x.seoDescription = metaTa.value;
        st.className = 'rowstate ok'; st.textContent = 'Saved';
        tr.classList.remove('dirty'); toast('Saved · ' + x.url); renderRows();
      }).catch(function (e) {
        st.className = 'rowstate bad'; st.textContent = 'Error: ' + (e && e.message || e); saveBtn.disabled = null;
        toast('Save failed', true);
      });
    });
    // image alt-text panel (products only), fetched on demand
    var imgBtn = null, altRow = null;
    if (x.type === 'product') {
      imgBtn = h('button', { class: 'btn sec imgbtn' }, ['Images']);
      imgBtn.addEventListener('click', function () {
        if (altRow) { altRow.remove(); altRow = null; imgBtn.classList.remove('on'); return; }
        imgBtn.classList.add('on');
        altRow = h('tr', { class: 'altrow' }, [h('td', { colspan: '5' }, [h('div', { class: 'altpanel' }, [h('span', { class: 'spinner' }), ' Loading images…'])])]);
        tr.after(altRow);
        var panel = altRow.querySelector('.altpanel');
        call('get_images', { id: x.id }).then(function (d) {
          var imgs = (d && d.images) || [];
          panel.innerHTML = '';
          if (!imgs.length) { panel.appendChild(h('div', { class: 'ag-muted' }, ['No images on this product.'])); return; }
          panel.appendChild(h('div', { class: 'althint' }, ['Ideal alt text: describe what is in the image in plain words (e.g. "Cast iron kettlebell, 6 kg, black"), helps Google Images + screen readers. Amber border = missing.']));
          imgs.forEach(function (im) { panel.appendChild(imgCard(im)); });
        }).catch(function (e) { panel.innerHTML = ''; panel.appendChild(h('div', { class: 'rowstate bad' }, ['Error: ' + (e && e.message || e)])); });
      });
    }
    tr.appendChild(h('td', { class: 'kind' }, [x.type]));
    tr.appendChild(h('td', { class: 'u' }, [h('a', { href: (CFG.storeUrl || '') + x.url, target: '_blank', rel: 'noopener' }, [x.url]),
      h('div', { class: 'ctx', title: esc(x.title) }, [esc(x.title)])]));
    tr.appendChild(h('td', null, [h('div', { class: 'fld' }, [titleIn, tMeter, sugBox('title', titleIn, x), sugBtn('title', titleIn, x)])]));
    tr.appendChild(h('td', null, [h('div', { class: 'fld' }, [metaTa, mMeter, sugBox('meta', metaTa, x), sugBtn('meta', metaTa, x)])]));
    tr.appendChild(h('td', null, [saveBtn, imgBtn, st]));
    return tr;
  }

  // "✨ Suggest". AI-drafts a title or meta description (Phase 2b); user reviews then Saves.
  function sugBtn(field, input, x) {
    if (!AI_SUGGEST) return null; // hidden by default, see AI_SUGGEST flag above
    var b = h('button', { class: 'btn sec sug', type: 'button', title: 'AI draft: review before saving' }, ['✨ Suggest']);
    b.addEventListener('click', function () {
      b.disabled = 'true'; b.classList.add('busy');
      call('suggest', { field: field, name: x.title, type: x.type }).then(function (d) {
        b.disabled = null; b.classList.remove('busy');
        if (d.error) {
          toast(d.error === 'no_api_key'
            ? 'AI draft not set up yet. Add ANTHROPIC_API_KEY in the Apps Script'
            : 'Suggest failed: ' + (d.message || d.error), true);
          return;
        }
        if (d.text) { input.value = d.text; input.dispatchEvent(new Event('input')); input.focus(); toast('Draft inserted, review, then Save'); }
      }).catch(function (e) { b.disabled = null; b.classList.remove('busy'); toast('Suggest failed: ' + (e && e.message || e), true); });
    });
    return b;
  }

  // "Suggested" box, pre-written drafts (window.AG_SEO_SUGGESTIONS, baked from
  // real product content) shown under a field. "Use" drops the draft into the
  // input as an unsaved edit, so the row goes amber (dirty) = flagged for you to
  // review and Save. Only shown where the field actually needs help (empty,
  // over-length, or a stuffed title) so healthy rows stay clean.
  function ruleTitle(x) {
    var name = (x.title || '').split('|')[0].trim().replace(/\s+/g, ' ');
    if (!name) return '';
    var withBrand = name + ' | ' + SHOP_NAME;
    if (titlePx(withBrand) <= TITLE_PX) return withBrand;
    // Too wide with the brand: drop trailing words from the name until the
    // rendered title (the theme re-adds the brand) fits.
    var words = name.split(' ');
    while (words.length > 1 && titlePx(words.join(' ') + ' | ' + SHOP_NAME) > TITLE_PX) words.pop();
    return words.join(' ');
  }
  function suggestionText(field, x) {
    var s = (window.AG_SEO_SUGGESTIONS || {})[x.url] || {};
    if (field === 'meta') return s.meta || '';   // metas are baked only
    return s.title || ruleTitle(x);               // titles fall back to a rule template
  }
  function fieldNeedsSuggestion(field, val, x) {
    var v = (val || '').trim();
    if (field === 'meta') return v.length === 0 || metaPx(v) > META_PX;
    return v.length === 0 || titlePx(renderedTitle(x, v)) > TITLE_PX || (v.split('|').length - 1) >= 2;
  }
  function sugBox(field, input, x) {
    if (!fieldNeedsSuggestion(field, input.value, x)) return null;
    var text = suggestionText(field, x);
    if (!text || text === (input.value || '').trim()) return null;
    var useBtn = h('button', { class: 'btn sec usebtn', type: 'button' }, ['Use']);
    var box = h('div', { class: 'sugbox' }, [
      h('span', { class: 'suglabel' }, ['Suggested']),
      h('span', { class: 'sugtext' }, [text]),
      useBtn
    ]);
    useBtn.addEventListener('click', function () {
      input.value = text;
      input.dispatchEvent(new Event('input')); // marks row dirty, updates meter, enables Save
      input.focus();
      box.classList.add('used');
      useBtn.disabled = 'true'; useBtn.textContent = '✓ Added, review & Save';
    });
    return box;
  }

  function imgCard(im) {
    var thumb = im.url ? im.url + (im.url.indexOf('?') < 0 ? '?' : '&') + 'width=128' : '';
    var input = h('input', { class: 'in altin', type: 'text', value: esc(im.alt), placeholder: 'Describe this image…' });
    var save = h('button', { class: 'save', disabled: 'true' }, ['Save']);
    var stt = h('span', { class: 'rowstate' }, ['']);
    input.addEventListener('input', function () { save.disabled = (input.value === esc(im.alt)) ? 'true' : null; });
    var card = h('div', { class: 'imgcard' + (im.alt && im.alt.trim() ? '' : ' noalt') }, [
      thumb ? h('img', { src: thumb, alt: '', loading: 'lazy' }) : h('div', { class: 'noimg' }, ['-']),
      h('div', { class: 'imgfld' }, [input, h('div', { class: 'imgactions' }, [save, stt])])
    ]);
    save.addEventListener('click', function () {
      save.disabled = 'true'; stt.className = 'rowstate'; stt.innerHTML = '<span class="spinner"></span>';
      call('save_alt', { mediaId: im.id, alt: input.value }).then(function (d) {
        if (d.userErrors && d.userErrors.length) { stt.className = 'rowstate bad'; stt.textContent = d.userErrors.map(function (u) { return u.message; }).join('; '); save.disabled = null; return; }
        im.alt = input.value; stt.className = 'rowstate ok'; stt.textContent = 'Saved'; toast('Alt saved'); card.classList.toggle('noalt', !input.value.trim());
      }).catch(function (e) { stt.className = 'rowstate bad'; stt.textContent = 'Error: ' + (e && e.message || e); save.disabled = null; });
    });
    return card;
  }

  // ---- deep audit view (history/trends) ----
  var AUDIT_DEFS = [
    { k: 'resources', l: 'Total resources', track: false },
    { k: 'noMeta', l: 'Missing meta', track: true },
    { k: 'metaLong', l: 'Meta over 160 chars (audit)', track: true },
    { k: 'titleLong', l: 'Titles over 60 chars (audit)', track: true },
    { k: 'titleStuffed', l: 'Stuffed titles', track: true },
    { k: 'imagesNoAlt', l: 'Images missing alt', track: true }
  ];
  function fmtDate(iso) {
    try { var d = new Date(iso); return d.toLocaleDateString(undefined, { day: '2-digit', month: 'short', year: '2-digit' }) + ' ' + d.toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit' }); }
    catch (e) { return String(iso).slice(0, 16); }
  }
  function auditView() {
    var wrap = h('div', { class: 'auditview' });
    var runBtn = h('button', { class: 'btn' }, ['Run audit now']);
    var status = h('span', { class: 'auditstatus ag-muted' }, ['']);
    var cards = h('div', { class: 'grid' });
    var hist = h('div', { class: 'audithist' });
    wrap.appendChild(h('div', { class: 'auditbar' }, [runBtn, status,
      h('span', { class: 'ag-muted', style: 'margin-left:auto;font-size:12px' }, ['Snapshots the whole store via the Admin API, no crawl, no rate limits.'])]));
    wrap.appendChild(cards);
    wrap.appendChild(h('div', { class: 'audithead' }, ['History']));
    wrap.appendChild(hist);

    function render(history) {
      var latest = history[history.length - 1], prev = history[history.length - 2];
      cards.innerHTML = '';
      if (!latest) { cards.appendChild(h('div', { class: 'ag-muted' }, ['No audits yet. Click "Run audit now" for the first snapshot.'])); hist.innerHTML = ''; return; }
      AUDIT_DEFS.forEach(function (d) {
        var v = latest[d.k], delta = (prev && d.track) ? v - prev[d.k] : 0, deltaEl = '';
        if (delta) deltaEl = h('span', { class: 'delta ' + (delta < 0 ? 'good' : 'bad') }, [(delta < 0 ? '▼ ' : '▲ ') + Math.abs(delta)]);
        cards.appendChild(h('div', { class: 'stat' + (d.track && v > 0 ? ' warn' : '') }, [
          h('div', { class: 'v' }, [String(v), deltaEl || '']), h('div', { class: 'l' }, [d.l])
        ]));
      });
      hist.innerHTML = '';
      var thead = h('tr', null, [h('th', null, ['Run'])].concat(AUDIT_DEFS.map(function (d) { return h('th', { class: 'num' }, [d.l]); })));
      var body = history.slice().reverse().map(function (r) {
        return h('tr', null, [h('td', { class: 'audittime' }, [fmtDate(r.ts)])].concat(AUDIT_DEFS.map(function (d) {
          return h('td', { class: 'num' + (d.track && r[d.k] > 0 ? ' col-warn' : '') }, [String(r[d.k])]);
        })));
      });
      hist.appendChild(h('div', { class: 'tablewrap' }, [h('table', null, [h('thead', null, [thead]), h('tbody', null, body)])]));
    }

    runBtn.addEventListener('click', function () {
      runBtn.disabled = 'true'; status.className = 'auditstatus'; status.innerHTML = '<span class="spinner"></span> Running…';
      call('run_audit', {}).then(function (d) {
        status.className = 'auditstatus col-ok'; status.textContent = 'Snapshot saved';
        render(d.history || []); runBtn.disabled = null;
      }).catch(function (e) { status.className = 'auditstatus col-bad'; status.textContent = 'Error: ' + (e && e.message || e); runBtn.disabled = null; });
    });
    call('get_history', {}).then(function (d) { render(d.history || []); })
      .catch(function (e) { cards.appendChild(h('div', { class: 'rowstate bad' }, ['Error loading history: ' + (e && e.message || e)])); });
    return wrap;
  }

  // ---- theme + toast ----
  function savedTheme() { try { return localStorage.getItem('ag-seo-theme') || 'light'; } catch (e) { return 'light'; } }
  function toggleTheme() { var t = savedTheme() === 'dark' ? 'light' : 'dark'; try { localStorage.setItem('ag-seo-theme', t); } catch (e) {} studio.setAttribute('data-theme', t); renderApp(); }
  var toastEl;
  function toast(msg, bad) {
    if (!toastEl) { toastEl = h('div', { class: 'toast' }); studio.appendChild(toastEl); }
    toastEl.className = 'toast' + (bad ? ' bad' : ''); toastEl.textContent = msg;
    requestAnimationFrame(function () { toastEl.classList.add('show'); });
    clearTimeout(toast._t); toast._t = setTimeout(function () { toastEl.classList.remove('show'); }, 2600);
  }

  // ---- boot ----
  // Simple loading state shown while the shell authenticates + data loads.
  // Its .ag-seo-progress element is updated by loadAll() ("Loaded N…").
  function renderLoading() {
    studio.setAttribute('data-theme', savedTheme());
    mount.innerHTML = '';
    mount.appendChild(h('div', { class: 'gate' }, [
      h('div', { class: 'ag-seo-progress ag-muted' }, ['Loading SEO data…'])
    ]));
  }

  if (window.AG_ADMIN && typeof window.AG_ADMIN.onReady === 'function') {
    // OTP shell present: it owns auth. Wait for a valid session, then load.
    renderLoading();
    window.AG_ADMIN.onReady(function () {
      loadAll().then(renderApp).catch(function (e) {
        // On auth failure the shell shows its own email/OTP overlay, don't
        // render our legacy gate on top of it. Otherwise show what we have.
        if (e && (e.auth || String(e && e.message) === 'auth')) return;
        renderApp();
      });
    });
  } else {
    // No shell (fallback): legacy staff-password gate.
    renderGate();
  }
})();
